function detectIsEmail(email: string): boolean {
	return /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+[a-z]{2,8}$/.test(email);
}

function detectIsPhone(phone: string): boolean {
	return /^((8|\+7)[\- ]?)?(\(?\d{3,5}\)?[\- ]?)?[\d\- ]{6,10}$/.test(phone);
}

function detectIsTaxCode(code: string): boolean {
	const multiplier10 = [2, 4, 10, 3, 5, 9, 4, 6, 8, 0];
	const multiplier11 = [7, 2, 4, 10, 3, 5, 9, 4, 6, 8, 0];
	const multiplier12 = [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8, 0];
	const valueAsString = code.toString();

	if (isNaN(+valueAsString)) {
		return false;
	}

	if (!/^\d{10,12}$/.test(valueAsString)) {
		return false;
	}

	const splitted = valueAsString.split('');

	if (splitted.length === 10 && !Number.isNaN(+splitted[splitted.length - 1])) {
		const lastNumber = +splitted[splitted.length - 1];
		const multiSum = splitted
			.map((v, index) => +v * multiplier10[index])
			.reduce((acc, v) => acc + v, 0);
		let controlValue = multiSum % 11;

		if (controlValue > 9) {
			controlValue = controlValue % 10;
		}

		return controlValue === lastNumber;
	}

	if (splitted.length === 12 && !Number.isNaN(+splitted[splitted.length - 1])) {
		const number11 = +splitted[splitted.length - 2];
		const number12 = +splitted[splitted.length - 1];
		const multiSum1 = splitted
			.slice(0, 11)
			.map((v, index) => +v * multiplier11[index])
			.reduce((acc, v) => acc + v, 0);
		let controlValue1 = multiSum1 % 11;

		if (controlValue1 > 9) {
			controlValue1 = controlValue1 % 10;
		}

		const multiSum2 = splitted
			.map((v, index) => +v * multiplier12[index])
			.reduce((acc, v) => acc + v, 0);
		let controlValue2 = multiSum2 % 11;

		if (controlValue2 > 9) {
			controlValue2 = controlValue2 % 10;
		}

		return controlValue1 === number11 && controlValue2 === number12;
	}

	return false;
}

export {
	detectIsEmail,
	detectIsPhone,
	detectIsTaxCode,
};
